<template>
  <BModalForm
    ref="modal"
    content-class="LKPassportModal"
    max-width="1200px"
  >
    <template #footer>
      <v-spacer />
    </template>

    <div class="LKPassportModal__DataTableContainer">
      <LKPassportTemplateTable
        :passport="data"
        :readonly="readonly"
        :detail-passport="data"
        :is-contextual-data="true"
        @input="onSave"
        @submit="onSubmit"
        @close="close"
      />
    </div>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import LKPassportTemplateTable from '@/views/LKPassport/components/LKPassportTemplateTable.vue'

export default {
  name: 'LKPassportContextualDataModal',
  components: {
    BModalForm,
    LKPassportTemplateTable,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    onContextsUpdated: {
      type: Function,
      required: true,
    },
    onContextsSubmit: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
  },
  data: () => ({
    isDeclined: false,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    onSave(contextsData) {
      try {
        return this.onContextsUpdated(this.data.id, { contexts: contextsData })
      } catch (e) {
        this.$notice.errors(e)
        return null
      }
    },
    onSubmit(contextsData) {
      try {
        return this.onContextsSubmit(this.data.id, { contexts: contextsData })
      } catch (e) {
        this.$notice.errors(e)
        return null
      }
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKPassportModal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-width: 800px;
  max-width: 1024px;
  max-height: calc(100% - #{2 * $modal-padding});
  margin: $modal-padding auto;
  overflow: none;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  & &__title {
    margin-top: 12px;
    font-size: 22px;
  }

  &__line {
    height: 1px;
    margin: 22px 0 30px 0;
    color: $webflow-color-alert-line;
    background-color: $webflow-color-alert-line;
    border: 0;
  }
}
</style>
